import { useState, useEffect } from 'react';

/**
 * Hook to manage ad frequency
 * Shows interstitial ads at appropriate intervals
 * 
 * @param {number} frequency - Show ad every N page views (default: 3)
 * @returns {Object} - { shouldShowAd, markAdShown }
 */
export const useAdFrequency = (frequency = 3) => {
  const [shouldShowAd, setShouldShowAd] = useState(false);

  useEffect(() => {
    const viewCount = parseInt(localStorage.getItem('adViewCount') || '0');
    const lastAdTime = parseInt(localStorage.getItem('lastAdTime') || '0');
    const currentTime = Date.now();
    
    // Show ad if:
    // 1. Reached frequency count
    // 2. At least 2 minutes passed since last ad
    const timeSinceLastAd = (currentTime - lastAdTime) / 1000 / 60; // minutes
    
    if (viewCount > 0 && viewCount % frequency === 0 && timeSinceLastAd >= 2) {
      setShouldShowAd(true);
    }
    
    // Increment view count
    localStorage.setItem('adViewCount', (viewCount + 1).toString());
  }, [frequency]);

  const markAdShown = () => {
    setShouldShowAd(false);
    localStorage.setItem('lastAdTime', Date.now().toString());
  };

  return { shouldShowAd, markAdShown };
};